<template>
  <div class="course">
    <div class="breadcrumb">
      {{currentCourse.name}}
    </div>
    <p class="tip-line">{{currentCourse.describe}}</p>
    <div class="course-wrapper">
      <div class="box">
        <div class="box-wrap" @click="openChapterDialog">
          <i class="iconfont icon-study"></i>
          <p class="name">章节目录</p>
          <p class="progress">共{{courseProgress.learning}}章</p>
        </div>
        <div class="box-wrap" @click="getData('wrong')">
          <i class="iconfont icon-file-wrong"></i>
          <p class="name">错题本</p>
          <p class="progress">{{courseProgress.wrong}}</p>
        </div>
        <div class="box-wrap" @click="getExamListInfo('mock')">
          <i class="iconfont icon-exam"></i>
          <p class="name">真题模考</p>
          <p class="progress">已完成 {{courseProgress.exam}} 套</p>
        </div>
      </div>
      <div class="box">
        <el-button
          type="primary"
          plain
          @click="openChapterDialog">
          已完成{{courseProgress.chapter}}章学习
        </el-button>
        <el-button type="primary" plain @click="toggleStatisticsDialog">学习统计</el-button>
        <el-button type="primary" plain @click="getExamListInfo('record')">考试记录</el-button>
      </div>
    </div>
    <van-quizzes-hk-dialog ref="quizzesHkDialog"
                           :is-exam-records="isExamRecords"
                           :is-exam="isExam"
                           :status="status"
                           :is-learning-exam="isLearningExam"
                           :exam-record-score="examRecordScore"
                           @continue="nextGroup"
                           @update-progress="getCourseProgress"
                           @close="closeQuizzesDialog" />
    <van-chapter-directory-dialog
      ref="chapter"
      @open-catalog="openCatalog"
      @review="review"
      @playVideo="playVideo" />
    <van-learn-statistics-dialog
      ref="statistics"
      v-if="showStatisticsDialog"
      @end="toggleStatisticsDialog">
    </van-learn-statistics-dialog>
    <van-exam-chapter-dialog
      ref="examChapter"
      @review="review"
      @record="openRecord"
      @closeExamList="closeExamList"
      :title="currentCourse.name"
      />
      <van-video-dialog
        ref="learning-video"
        :title="videoTitle"
        @complete-knowledge="completeKnowledge"
        @continue="againLearning" />
  </div>
</template>

<script>
// import { Row, Col } from 'element-ui';
import VanVideoDialog from '@/components/quizzes/hk/VideoDialog.vue';
import VanQuizzesHkDialog from '@/components/quizzes/hk/HkDialog.vue';
import VanChapterDirectoryDialog from '@/components/quizzes/hk/ChapterDirectoryDialog.vue';
import VanLearnStatisticsDialog from '@/components/quizzes/hk/LearnStatisticsDialog.vue';
import VanExamChapterDialog from '@/components/quizzes/hk/ExamChapterDialog.vue';
import api from '@/api/graphql/learning';
import { mapGetters, mapActions } from 'vuex';
import {
  COURSE_LIST,
  COURSE_DATA,
  FETCH_COURSE_DATA,
  // CURRENT_COURSE,
} from '@/store/learning/types';
import utils from '@/services/utils';

export default {
  components: {
    VanQuizzesHkDialog,
    VanChapterDirectoryDialog,
    VanLearnStatisticsDialog,
    // VanExamRecordsDialog,
    VanExamChapterDialog,
    VanVideoDialog,
  },
  data() {
    return {
      courseProgress: {},
      lastType: '',
      isExam: false,
      isLearningExam: false,
      showStatisticsDialog: false,
      typeInfo: {},
      isExamRecords: false, // 查看报告, 传给 hkDialog
      examRecordScore: 0, // 查看报告的时候的分值，传给 hkDialog
      examListType: '', // 真题的类型['mock','record']
      currentCourse: {},
      currentChapter: {},
      status: 0,
      videoTitle: '',
    };
  },
  computed: {
    ...mapGetters({
      courseData: COURSE_DATA,
      courseList: COURSE_LIST,
      // currentCourse: CURRENT_COURSE,
    }),
    courseId() {
      return Number(this.$route.params.courseId) || 0;
    },
  },
  watch: {
    $route() {
      this.getCourseProgress();
    },
  },
  methods: {
    ...mapActions({
      fetchCourseData: FETCH_COURSE_DATA,
    }),
    openChapterDialog() {
      this.$refs.chapter.open();
    },
    getData(type, other = {}) {
      this.lastType = type;
      this.typeInfo.type = this.lastType;
      this.fetchCourseData({
        courseId: this.courseId,
        type,
        ...this.typeInfo,
      })
        .then(({ courseData }) => {
          this.status = courseData.status;
          this.isExam = (type === 'exam' || other.action === 'exam' || courseData.type === 'exam' || type === 'chapter');
          this.isLearningExam = (type === 'learning' && courseData.type === 'exam');
          this.$refs.quizzesHkDialog.open();
        })
        .catch((error) => {
          if (error && error.code === 1033) {
            utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '知道了',
              center: true,
            });
          } else {
            utils.error(error.message);
            this.$refs.quizzesHkDialog.error(error);
          }
        });
    },
    getCourseProgress() {
      const { courseId } = this.$route.params;
      api.getCourseProgress({
        courseId,
      }).then(({ courseProgress }) => {
        this.courseProgress = courseProgress;
      });
    },
    nextGroup() {
      this.getCourseProgress();
      this.getData(this.lastType);
    },
    toggleStatisticsDialog() {
      this.showStatisticsDialog = !this.showStatisticsDialog;
    },
    review(payload) {
      const { type } = payload;
      if (payload && (payload.action === 'examination' || type === 'section' || type === 'chapter')) {
        this.againLearning(payload);
      } else {
        this.$refs['learning-video'].playVideo(payload.chapterId, 'pass', payload);
      }
    },
    completeKnowledge() {
      this.$refs.chapter.update();
    },
    closeQuizzesDialog() {
      if (this.isExamRecords) {
        // 退出考试记录
        this.isExamRecords = false;
      } else if (this.lastType === 'review' || this.lastType === 'learning') {
        this.$refs.chapter.selectChapter();
      } else if (this.lastType === 'exam' || this.lastType === 'chapter') {
        if (this.examListType) {
          this.$refs.examChapter.update();
          this.getCourseProgress();
        }
        // 回收每次去请求真题id
        this.typeInfo = {};
      }
    },
    getExamListInfo(type, id) {
      this.examListType = type;
      this.$refs.examChapter.open(type, id);
    },
    openRecord(payload) {
      // 打开记录的入口点
      this.isExamRecords = true;
      const {
        type,
        id,
        score,
        action,
      } = payload;
      this.typeInfo = {
        type,
        id,
        action,
      };
      this.examRecordScore = score;
      this.$refs.chapter.selectChapter();
      // this.getData(payload.type, payload);
      this.getData(type, { type, id });
    },
    openCatalog(args) {
      this.getExamListInfo(args.type, args.id);
    },
    closeExamList() {
      this.examListType = '';
      this.isExamRecords = false;
    },
    playVideo(payload) {
      this.videoTitle = payload.name;
      if (payload.action === 'section') {
        this.$refs['learning-video'].playVideo(0, 'section', payload);
      } else {
        this.currentChapter = payload;
        this.$refs['learning-video'].playVideo(payload.id, 'active', payload);
      }
    },
    againLearning(payload) {
      this.typeInfo = payload;
      this.getData(payload.type, payload);
    },
  },
  created() {
    this.getCourseProgress();
  },
  beforeRouteEnter(to, from, next) {
    const bookInfo = utils.storage('bookInfo');
    if (bookInfo) {
      next((vm) => {
        vm.currentCourse = bookInfo;
      });
    } else {
      next({
        path: '/learning-center/elective',
        replace: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/common/tip-line.scss';

  .course {
    .expire-time {
      box-sizing: border-box;
      width: 100%;
    }
    .course-wrapper {
      position: absolute;
      top: 50%;
      transform: translateY(-40%);
      padding: 0 20px;
      width: 100%;
      .box {
        display: flex;
        justify-content: center;
        text-align: center;
        .box-wrap {
          position: relative;
          cursor: pointer;
          width: 200px;
          height: 200px;
          margin: 0 20px;
          border: 2px solid $primary;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: $primary;
          font-size: 16px;
          p {
            margin-bottom: 0;
          }
          .progress {
            margin-top: 8px;
            color: $grey-color;
          }
          i {
            font-size: 64px;
          }
        }
        .el-button {
          margin: 20px 20px 0;
          width: 204px;
        }
      }
    }
  }
</style>
